module.exports = __webpack_public_path__ + "img/7.dcc12f84.png";